import React from "react";
import ScrollProgress from "./components/ScrollProgress";
import HRNavBar from "./components/HRNavBar";
import HRFooter from "./components/HRFooter";

// Light HR shell: paper ground, ink text, Hanken Grotesk.
// navVariant="video" drops main's top padding so a full-screen hero can sit
// under the transparent nav; "solid" pages get pt-20 (nav is fixed h-20).
export default function HRLayout({ navVariant = "solid", navMode = "site", children }) {
  return (
    <div className="hr-root min-h-screen bg-paper text-ink font-hanken antialiased selection:bg-royal/15 selection:text-ink">
      <ScrollProgress />
      <HRNavBar variant={navVariant} mode={navMode} />
      <main className={navVariant === "video" ? "relative" : "relative pt-20"}>{children}</main>
      {navMode !== "dashboard" && <HRFooter />}
    </div>
  );
}
